import React, { FC, useCallback, useMemo } from 'react'
import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import useMediaQuery from '@mui/material/useMediaQuery'
import Box from '@mui/material/Box'

import {
  getDateString,
  getDaysFromToday,
} from '@kaidam/fc-shared/src/booking/utils'

import icons from '../../icons'
const FastNextIcon = icons.fastNext
const FastPreviousIcon = icons.fastPrevious
const NextIcon = icons.next
const PreviousIcon = icons.previous

const useStyles = makeStyles(theme => ({
}))

interface DateNavigatorProps {
  value: string,
  disablePast?: boolean,
  onChange: {
    (val: string): void,
  }
}


const DateNavigator: FC<React.PropsWithChildren<DateNavigatorProps>> = ({
  value,
  disablePast = false,
  onChange,
}) => {
  const classes = useStyles()

  const theme = useTheme()
  const isLarge = useMediaQuery(theme.breakpoints.up('md'))

  const daysFromToday = useMemo(() => {
    return getDaysFromToday(value)
  }, [
    value,
  ])

  const onMove = useCallback((days: number) => {
    const dt = new Date(value)
    dt.setTime(dt.getTime() + days * 24 * 60 * 60 * 1000)
    onChange(getDateString(dt))
  }, [
    value,
  ])

  const back = (
    <Box 
      className='buttons'
      sx={{
        p: 1,
      }}
    >
      <IconButton onClick={ () => onMove(-7) } size="large">
        <FastPreviousIcon />
      </IconButton>
      <IconButton onClick={ () => onMove(-1) } size="large">
        <PreviousIcon />
      </IconButton>
    </Box>
  )

  const forward = (
    <Box
      className='buttons'
      sx={{
        p: 1,
      }}
    >
      <IconButton onClick={ () => onMove(1) } size="large">
        <NextIcon />
      </IconButton>
      <IconButton onClick={ () => onMove(7) } size="large">
        <FastNextIcon />
      </IconButton>
    </Box>
  )

  return (
    <>
      <Box
        className='row'
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {
          isLarge && (
            back
          )
        }
        <Box
          className='datePicker'
          sx={{
            mt: 0,
          }}
        >
          <TextField
            label="Date"
            type="date"
            value={ value }
            onChange={ (ev) => {
              onChange(ev.target.value)
            }}
            sx={{
              '& label': {
                left: '35px',
                whiteSpace: 'nowrap',
              },
              '& input': {
                textAlign: 'center',
              },
            }}
          />
        </Box>
        {
          isLarge && (
            forward
          )
        }
      </Box>
      {
        !isLarge && (
          <Box
            className='row'
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {
              back
            }
            {
              forward
            }
          </Box>
        )
      }
    </>
  )
}

export default DateNavigator